export type RsvpStatus = 'ACCEPTED' | 'DECLINED' | 'MAYBE';

export const RSVP_STATUS_LABEL: Record<RsvpStatus, string> = {
  ACCEPTED: 'Accepted',
  DECLINED: 'Declined',
  MAYBE: 'Maybe',
};

export interface Rsvp {
  id: string;
  invitationId: string;
  guestName: string;
  guestEmail?: string | null;
  status: RsvpStatus;
  headcount: number;
  message?: string | null;
  respondedAt: string;
}

export interface RsvpStatusCounts {
  count: number;
  headcount: number;
}

export interface RsvpSummary {
  total: number;
  totalHeadcount: number;
  byStatus: Record<RsvpStatus, RsvpStatusCounts>;
}

export interface SubmitRsvpPayload {
  guestName: string;
  guestEmail?: string;
  status: RsvpStatus;
  headcount?: number;
  message?: string;
}

export interface RsvpAnalytics {
  total:          number;
  accepted:       number;
  declined:       number;
  maybe:          number;
  totalHeadcount: number;
  acceptanceRate: number;
  declineRate:    number;
  responseRate:   number;
  pendingRate:    number;
  attendanceForecast: number;
  timeSeries: Array<{ date: string; count: number }>;
}

export type RsvpSortField = 'latest' | 'oldest' | 'name' | 'headcount';

export interface PaginationMeta {
  page: number;
  limit: number;
  total: number;
  totalPages: number;
}

export interface RsvpListResponse {
  items: Rsvp[];
  meta: PaginationMeta;
}

export interface ListRsvpsQuery {
  page?:   number;
  limit?:  number;
  search?: string;
  status?: string;
  sort?:   RsvpSortField;
}
